"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfRequestedOrientationDto = instanceOfPaginatedResponseOfRequestedOrientationDto;
exports.PaginatedResponseOfRequestedOrientationDtoFromJSON = PaginatedResponseOfRequestedOrientationDtoFromJSON;
exports.PaginatedResponseOfRequestedOrientationDtoFromJSONTyped = PaginatedResponseOfRequestedOrientationDtoFromJSONTyped;
exports.PaginatedResponseOfRequestedOrientationDtoToJSON = PaginatedResponseOfRequestedOrientationDtoToJSON;
exports.PaginatedResponseOfRequestedOrientationDtoToJSONTyped = PaginatedResponseOfRequestedOrientationDtoToJSONTyped;
const PaginationMetaDto_1 = require("./PaginationMetaDto");
const RequestedOrientationDto_1 = require("./RequestedOrientationDto");
/**
 * Check if a given object implements the PaginatedResponseOfRequestedOrientationDto interface.
 */
function instanceOfPaginatedResponseOfRequestedOrientationDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfRequestedOrientationDtoFromJSON(json) {
    return PaginatedResponseOfRequestedOrientationDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfRequestedOrientationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(RequestedOrientationDto_1.RequestedOrientationDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfRequestedOrientationDtoToJSON(json) {
    return PaginatedResponseOfRequestedOrientationDtoToJSONTyped(json, false);
}
function PaginatedResponseOfRequestedOrientationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(RequestedOrientationDto_1.RequestedOrientationDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfRequestedOrientationDto.js.map